export const choo = {
    data: {
        vertical: {
            car: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/choo/images/logo-large.png',
                    header_logo_image_url_small: null,
                    error_page_quote_something_went_wrong_image_url: null,
                    quote_expired_screen_image_url: null,
                    rego_lookup_loading_screen_hero_image_url: null,
                    welcome_back_hero_image_url: null,
                    price_confidence_banner_mobile_url: null,
                    price_confidence_banner_tablet_url: null,
                    price_confidence_banner_desktop_url: null
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: 'https://app.choosi.com.au/evt/assets/car-insurance/brand/choo/pdf/privacy_policy.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://app.choosi.com.au/evt/assets/car-insurance/brand/choo/pdf/FSG.pdf',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://app.choosi.com.au/evt/assets/car-insurance/brand/choo/pdf/website_terms_of_use.pdf',
                    footer_disclaimer_how_comparison_works_url: null,
                    footer_disclaimer_financial_services_guide_url: 'https://app.choosi.com.au/evt/assets/car-insurance/brand/choo/pdf/FSG.pdf',
                    footer_disclaimer_terms_of_use_url: 'https://app.choosi.com.au/evt/assets/car-insurance/brand/choo/pdf/website_terms_of_use.pdf',
                    footer_copyright_banner_privacy_policy_url: 'https://app.choosi.com.au/evt/assets/car-insurance/brand/choo/pdf/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://app.choosi.com.au/evt/assets/car-insurance/brand/choo/pdf/website_terms_of_use.pdf',
                    header_logo_image_link: 'https://www.choosi.com.au/'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'Choosi',
                    application_details_opt_in_checkbox_brand_name: 'Choosi',
                    rego_lookup_licence_plate_placeholder: '123CHOO',
                    rego_lookup_default_licence_plate_state_label: 'Choosi',
                    rego_lookup_welcome_message: "Welcome to Choosi. We're here to help you find a great deal on car insurance."
                }
            },
            home: {
                media: {
                    header_logo_image_url: '/evt/assets/brand/choo/images/logo-large.png',
                    header_logo_image_url_small: null,
                    error_page_quote_something_went_wrong_image_url: null,
                    shielded_thank_you_hero_image_url: null,
                    welcome_back_hero_image_url: null,
                    price_confidence_banner_mobile_url: null,
                    price_confidence_banner_tablet_url: null,
                    price_confidence_banner_desktop_url: null
                },
                links: {
                    application_details_opt_in_checkbox_privacy_policy_url: 'https://app.choosi.com.au/evt/assets/home-contents-insurance/brand/choo/pdf/privacy_policy.pdf',
                    application_details_opt_in_checkbox_financial_services_guide_url: 'https://app.choosi.com.au/evt/assets/home-contents-insurance/brand/choo/pdf/FSG.pdf',
                    application_details_opt_in_checkbox_terms_of_use_url: 'https://app.choosi.com.au/evt/assets/home-contents-insurance/brand/choo/pdf/website_terms_of_use.pdf',
                    footer_disclaimer_how_comparison_works_url: null,
                    footer_disclaimer_financial_services_guide_url: 'https://app.choosi.com.au/evt/assets/home-contents-insurance/brand/choo/pdf/FSG.pdf',
                    footer_disclaimer_terms_of_use_url: 'https://app.choosi.com.au/evt/assets/home-contents-insurance/brand/choo/pdf/website_terms_of_use.pdf',
                    footer_copyright_banner_privacy_policy_url: 'https://app.choosi.com.au/evt/assets/home-contents-insurance/brand/choo/pdf/privacy_policy.pdf',
                    footer_copyright_banner_terms_of_use_url: 'https://app.choosi.com.au/evt/assets/home-contents-insurance/brand/choo/pdf/website_terms_of_use.pdf',
                    header_logo_image_link: 'https://www.choosi.com.au/'
                },
                copy: {
                    footer_copyright_banner_brand_name: 'Choosi',
                    application_details_opt_in_checkbox_brand_name: 'Choosi'
                }
            }
        },
        design_system: {
            everest: {
                brand_primary: '#00AFD8',
                brand_secondary: '#FE5A19',
                brand_base: '#333333',
                feature_1: '#00AFD8',
                feature_2: '#FE5A19',
                feature_3: '#ef5123',
                feature_4: '#ef425e',
                brand_primary_120: '#009BCE',
                brand_primary_80: '#33BFE0',
                brand_primary_60: '#66CFE8',
                brand_primary_30: '#B3E7FS',
                brand_primary_10: '#E6F7FB',
                brand_secondary_120: '#FE3100',
                brand_secondary_80: '#FE7B47',
                brand_secondary_60: '#FE9C75',
                brand_secondary_30: '#FFCEBA',
                brand_secondary_10: '#FFEFE8',
                brand_base_120: '#000000',
                brand_base_80: '#666666',
                brand_base_60: '#999999',
                brand_base_20: '#dddddd',
                brand_base_10: '#f3f3f3',
                brand_base_0: '#ffffff',
                feature_1_120: '#009BCE',
                feature_1_80: '#33BFE0',
                feature_1_60: '#66CFE8',
                feature_1_30: '#B3E7FS',
                feature_1_10: '#E6F7FB',
                feature_2_120: '#f18600',
                feature_2_80: '#f6b14b',
                feature_2_60: '#f8c578',
                feature_2_30: '#fce2bc',
                feature_2_10: '#fef5e9',
                feature_3_120: '#eb2500',
                feature_3_80: '#f2744f',
                feature_3_60: '#f5977b',
                feature_3_30: '#facbbd',
                feature_3_10: '#fdeee9',
                feature_4_120: '#d31130',
                feature_4_80: '#f2687e',
                feature_4_60: '#f58e9e',
                feature_4_30: '#fac7cf',
                feature_4_10: '#fdecef',
                body_color: '#333333',
                body_background_color: '#f3f3f3',
                validation_success_color: '#00AFD8',
                validation_error_color: '#ef425e',
                validation_error_bg_color: '#fdecef',
                form_label_color: '#003753',
                color_border_default: '#dddddd',
                color_border_input_default: '#A0A1A2',
                modal_overlay_dark: 'rgba(0, 0, 0, 0.7)',
                modal_overlay_light: 'rgba(255, 255, 255, 0.3)',
                family_base: 'Arial, Helvetica, sans-serif',
                family_heading: 'Arial, Helvetica, sans-serif',
                medicare_green: '#b9f79e',
                medicare_blue: '#d4eef5',
                medicare_yellow: '#f7e97b',
                energy_secondary_button: '#0ec228',
                energy_secondary_button_120: '#0ea324',
                energy_primary_button: '#0ec228',
                energy_primary_button_120: '#0ea324',
                result_hint_yellow: '#f0e599',
                energy_feature_blue: '#001443',
                energy_label_highlight_blue: '#e7f2fd',
                a_link: '#00AFD8',
                input_border_radius: '0px',
                next_button_border_radius: '1rem',
                handover_button_border_radius: '1rem',
                progress_bar_inactive: '#ffffff',
                progress_bar_active: '#FE5A19',
                radio_input_color: '#2968F8',  // radio filter button results page
                radio_icon_color: '#00AFD8', // radio group icon color
                call_options_icon_inactive: '#00AFD8',
                call_options_icon_active: '#00AFD8',
                background_theme_color: '#1c3e93',
                font_40: '4rem',
                font_32: '3.2rem',
                font_24: '2.4rem',
                font_20: '2rem',
                font_18: '1.8rem',
                font_16: '1.5rem',
                font_14: '1.4rem',
                font_12: '1.2rem',
                font_10: '1rem'
            }
        }
    }
};
